import { useMemo } from "react";

import { isFieldEnrolled, useGetAllFieldPracticesByFarm, useGetPracticeCrops, usePracticeManagementCropParameters } from "utils";

import { FarmResponse } from "models";

import { getFieldCompletenessStatus } from "pages/app/all-field-view/utils/AllFieldsUtils";

export type FieldStatus = { enrolled: boolean; isComplete: boolean; missingCount: number };

export const useFieldStatusMap = (currentFarm: FarmResponse | undefined, reportingYear: number): Record<string, FieldStatus> => {
  const { data: allFieldsPractices } = useGetAllFieldPracticesByFarm(currentFarm);
  const { data: practiceCrops } = useGetPracticeCrops({});
  const { data: cropParameters } = usePracticeManagementCropParameters();

  return useMemo(() => {
    if (!allFieldsPractices) return {};
    const carbonProgram = currentFarm?.carbonProgram ?? null;

    return Object.entries(allFieldsPractices).reduce(
      (acc, [fieldId, fieldPractice]) => {
        const { availablePracticeBundles, crops, practices } = fieldPractice;
        const enrolled = isFieldEnrolled(availablePracticeBundles, carbonProgram);
        // shared with Field Details' payout badge, so both agree on what "complete" means
        const { isComplete, allMissingDataYears } = getFieldCompletenessStatus({
          crops,
          practices,
          availablePracticeBundles,
          carbonProgram,
          activeFarmReportingYear: reportingYear,
          practiceCrops,
          cropParameters,
        });

        acc[fieldId] = { enrolled, isComplete, missingCount: allMissingDataYears.length };
        return acc;
      },
      {} as Record<string, FieldStatus>
    );
  }, [allFieldsPractices, currentFarm?.carbonProgram, reportingYear, practiceCrops, cropParameters]);
};
